<template lang="html">
  <div class="fill-height secondary">
    <vue-particles
      color="#64FFDA"
      :particle-opacity="0.2"
      :particles-number="80"
      shape-type="circle"
      :particle-size="4"
      lines-color="#64FFDA"
      :lines-width="1"
      :line-linked="true"
      :line-opacity="0.4"
      :lines-distance="150"
      :move-speed="3"
      :hover-effect="true"
      hover-mode="grab"
      :click-effect="true"
      click-mode="push"
      style="height:98vh; position:absolute; width:100vw"
    />
    <v-container
      fluid
      fill-height
    >
      <v-layout
        align-center
        justify-center
      >
        <v-flex
          xs12
          sm8
          md5
          style="max-width:500px"
        >
          <!-- <v-container fluid >
                <v-layout align-center justify-center>
                </v-layout>

              </v-container> -->
          <v-card class="">
            <v-card-title>
              <v-spacer />
              <SiLogo size="36" />
              <v-spacer />
            </v-card-title>
            <v-progress-linear
              :indeterminate="true"
              :active="loading"
              class="ma-0"
              :height="2"
            />
            <v-card-text>
              <v-form
                ref="form"
                @submit.prevent=""
              >
                <v-expand-transition>
                  <v-text-field
                    v-if="showEmail"
                    ref="email"
                    v-model="email"
                    label="Email"
                    name="email"
                    prepend-icon="person"
                    type="text"
                    validate-on-blur
                    :rules="[emailValidator('You must provide a valid email')]"
                    :error="(errorMessages || []).length > 0"
                    :error-messages="showPassword ? [] : errorMessages"
                    @keydown.enter.stop="emailEnterDown"
                  />
                </v-expand-transition>

                <v-expand-transition>
                  <div v-if="showPassword">
                    <v-text-field
                      ref="password"
                      v-model="password"
                      label="Password"
                      name="password"
                      prepend-icon="lock"
                      :type="passwordVisible ? 'text' : 'password'"
                      :error-messages="errorMessages"
                      :append-icon="passwordVisible ? 'visibility_off' : 'visibility'"
                      @click:append="passwordVisible = !passwordVisible"
                      @keydown.enter="signIn"
                    />
                  </div>
                </v-expand-transition>

                <!-- <v-expand-transition>
                          <div v-if="!resetPasswordActive">
                            <v-flex pa-0 text-right class="caption">
                              <a  class="pointer primary--text" @click="resetPasswordRequest">Forgot password?</a>
                            </v-flex>
                          </div>
                        </v-expand-transition> -->

                <v-expand-transition>
                  <div v-if="showResetMessage">
                    An email with instructions to reset your password has been sent to <strong>{{ email }}</strong>
                  </div>
                </v-expand-transition>
              </v-form>
            </v-card-text>
            <v-expand-transition>
              <v-card-actions>
                <v-btn
                  v-if="resetPasswordActive && !resetEmailSent"
                  text
                  color="grey"
                  @click.prevent.native="cancelResetPassword"
                >
                  Cancel
                </v-btn>
                <v-btn
                  v-if="!resetPasswordActive"
                  text
                  color="grey"
                  @click.prevent.native="resetPasswordRequest"
                >
                  Forgot password
                </v-btn>
                <v-spacer />
                <v-btn
                  v-if="!resetPasswordActive"
                  :loading="loading"
                  color="primary"
                  @click.native="signIn"
                >
                  Login
                </v-btn>
                <v-btn
                  v-if="resetPasswordActive && !resetEmailSent"
                  :loading="loading"
                  color="primary"
                  @click.native="resetPassword"
                >
                  Reset Password
                </v-btn>
                <v-btn
                  v-if="resetEmailSent"
                  color="primary"
                  @click="resetLogin"
                >
                  Ok
                </v-btn>
              </v-card-actions>
            </v-expand-transition>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { auth } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
export default {
  mixins: [ helpers ],
  data () {
    return {
      loading: false,
      email: '',
      password: '',
      passwordVisible: false,
      errorMessages: [],
      resetPasswordActive: false,
      resetEmailSent: false,
      showEmail: true,
      showPassword: true,
      showResetMessage: false
      // actions: true,
    }
  },
  computed: {
    ...mapGetters(['_user'])
  },
  mounted () {
    requestAnimationFrame(() => {
      this.$refs.email.focus()
    })
  },
  methods: {
    emailEnterDown () {
      if (this.resetPasswordActive) {
        this.resetPassword()
      } else {
        if (this.$refs.password) this.$refs.password.focus()
      }
    },
    emailValidator (msg) {
      return v => {
        var errorMsg = msg || 'Please provide a valid email address.'
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return v ? pattern.test(v) || errorMsg : true
      }
    },
    signIn () {
      this.loading = true
      this.error = false
      this.errorMessages = []

      const signIn = () => {
        auth.signInWithEmailAndPassword(this.email || '', this.password || '')
          .catch(error => {
            // console.error(error)
            this.loading = false
            this.errorActions()
            this.error = true
            this.errorMessages.push(this.errorMessageText(error.code))
          })
        var authWatch = auth.onAuthStateChanged(user => {
          if (user) {
            this.$store.commit('set_user', user)
            if (user.isAnonymous) this.$router.replace('/')
            if (this.$route.query.redirect) {
              this.$router.replace(this.$route.query.redirect)
            } else {
              this.$router.replace('/')
            }
            authWatch()
          }
        })
      }

      if (auth.currentUser) {
        auth.signOut().then(() => {
          signIn()
        }).catch(console.error)
      } else {
        signIn()
      }
    },
    resetPasswordRequest () {
      var email = this.email.toString()
      this.errorMessages = []
      this.$refs.form.reset()
      this.$refs.email.focus()
      this.$nextTick(() => { this.email = email })
      this.showEmail = true
      this.showPassword = false
      this.resetPasswordActive = true
    },
    cancelResetPassword () {
      this.showEmail = true
      this.showPassword = true
      this.resetPasswordActive = false
    },
    resetPassword () {
      if (!this.$refs.form.validate()) return
      this.loading = true
      auth.sendPasswordResetEmail(this.email)
        .then(() => {
          this.showEmail = false
          this.showPassword = false
          this.showResetMessage = true
          this.loading = false
          this.resetEmailSent = true
          // this.actions = false
        })
        .catch(error => {
          this.loading = false
          // this.error = true
          this.errorMessages.push(this.errorMessageText(error.code))
          // console.error(error)
        })
    },
    resetLogin () {
      this.errorMessages = []
      this.resetPasswordActive = false
      this.resetEmailSent = false
      this.showEmail = true
      this.showPassword = true
      this.showResetMessage = false
    },
    errorActions () {
      // TODO: handle errors. Such as offer sign up if user does not exist
    },
    errorMessageText (code) {
      switch (code) {
        case 'auth/argument-error': return 'Please provide a valid password.'
        case 'auth/wrong-password': return 'Incorect password.'
        case 'auth/user-not-found': return 'This account does not exist.'
        case 'auth/invalid-email': return 'The email you entered is not valid.'
        case 'auth/network-request-failed': return 'There was a network error while trying to sign you in. Please try again'
        case 'auth/too-many-requests': return 'Too many failed attempts. Please wait a while and try again later.'
        case 'auth/user-disabled': return 'This account has been disabled. Please contact your administrator, or support'
        default: return 'There was an error signing you in'
      }
    }
  }
}
</script>

<style scoped>

</style>
